import type { Message } from '@/types';

/**
 * Union two message lists by id (incoming wins) and keep chronological order.
 * Used when an open thread is refreshed from the API or a live event arrives.
 */
export function mergeMessageLists(prev: Message[], incoming: Message[]): Message[] {
  const byId = new Map<string, Message>();
  for (const message of prev) {
    byId.set(message.id, message);
  }
  for (const message of incoming) {
    const known = byId.get(message.id);
    // A live event carries no email detail (#3736); never let it drop the fetched one.
    byId.set(message.id, known?.email && !message.email ? { ...message, email: known.email } : message);
  }
  return [...byId.values()].sort((a, b) => {
    const byTime = a.sentAt.localeCompare(b.sentAt);
    return byTime !== 0 ? byTime : a.id.localeCompare(b.id);
  });
}

export function messagesAddedSince(prev: Message[], next: Message[]): Message[] {
  const known = new Set(prev.map((message) => message.id));
  return next.filter((message) => !known.has(message.id));
}
